import { createInstance } from '@datapunt/matomo-tracker-react';
import { pipe } from '../../../shared/misc';
import applyDefaults from './apply-default';
import schema from './schema';
import { getSettingsById, isActiveById } from '../../utils';
import { MODULE_NAME } from './constant';

export const getMatomoInstance = pipe(applyDefaults, schema.parse, createInstance);

export const isActive = () => isActiveById(MODULE_NAME);
export const getSettings = () => getSettingsById(MODULE_NAME);
